import { Actions } from 'ha/modules/RealtimeMessaging/constants';

interface Action {
  type: Actions;
}

export const isRecieveMessageAction = (action: Action) =>
  action.type === Actions.RECEIVE_MESSAGE;
